module.exports = __webpack_public_path__ + "img/h6.d31f2d06.png";